// extracted by mini-css-extract-plugin
export default {"sba-tag-root":"SBATag_sba-tag-root__yrJbV","is-pending":"SBATag_is-pending__r4yIM","suspended":"SBATag_suspended__oq827","expired":"SBATag_expired__tzzXU"};